import { LanguageContext } from '@/helpers/LanguageContext'
import { useContext } from 'react'

export const useLanguage = () => {
  const context = useContext(LanguageContext)
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider')
  }
  return context
}
